import { UiButton, UiHeading } from "@frontend/roz-uikit";

import { useThirdPartiesStore } from "@/ui-state";

export const ThirdParty = () => {
  const { onSuccess, onReject } = useThirdPartiesStore();

  return (
    <div className="sdkui:py-4 sdkui:md:px-4 sdkui:md:py-4 sdkui:2xl:max-w-[30vw]">
      <UiHeading align="center" size="h5">
        Вы почти на месте! <br /> Следующий шаг - на странице нашего партнера,
        это безопасно.
      </UiHeading>
      <div className="sdkui:mt-7.5 sdkui:grid sdkui:grid-cols-1 sdkui:s:grid-cols-2 sdkui:gap-5">
        <UiButton
          className="sdkui:w-full"
          onClick={onSuccess}
          variant="primary"
        >
          Перейти
        </UiButton>
        <UiButton
          className="sdkui:w-full"
          onClick={onReject}
          variant="outlineDark"
        >
          Не переходить
        </UiButton>
      </div>
    </div>
  );
};
